<template>
  <!-- 设备本地日志 -->
  <div>
    <div>
      <div class="mb10">
        <v-input
              :disabled="disable"
              class=""
              v-model="searchValue"
              :placeholder="placeholder"
              suffix-icon="v-icon-search"
              @change="getData"
        ></v-input>
        <span class="visontips">默认显示200条数据, 请及时删除, 文件名仅支持左模糊匹配</span>
      </div>
      <div>
        <vxe-table
          row-id="id"
          :data="table"
          align="left"
          :row-style="setRowClass"
        >
          <vxe-table-column
            field="file_name"
            show-overflow
            min-width="120"
            title="文件名"
          ></vxe-table-column>
          <vxe-table-column
            field="key"
            show-overflow
            min-width="120"
            title="Key"
          ></vxe-table-column>
          <vxe-table-column
            field="e_tag"
            show-overflow
            min-width="120"
            title="MD5"
          ></vxe-table-column>
          <vxe-table-column
            field="type"
            show-overflow
            min-width="120"
            title="类型"
          ></vxe-table-column>
          <vxe-table-column
            field="size"
            show-overflow
            min-width="120"
            title="大小（字节）"
          ></vxe-table-column>
          <vxe-table-column
            field="last_modified_time_fmt"
            show-overflow
            min-width="120"
            title="时间"
          ></vxe-table-column>


          <vxe-column title="操作" min-width="140">
            <template v-slot="slotProps">
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn2"
                  slot="reference"
                  @click="showDownModel(slotProps.row)"
                  >下载</v-button
                ></span
              >
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn2"
                  slot="reference"
                  @click="showDelModel(slotProps.row)"
                  >删除</v-button
                ></span
              >
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <v-pagination
        v-if="total"
        @change-page="changePage"
        @change-size="changeSize"
        :total="total"
        name="page-basic"
        is-show-total
        is-change-size
        :current-page="this.currentPage"
      ></v-pagination>
    </div>

    <Del
      :showInputDialog.sync="Delloading"
      ref="Del"
      :file_url="file_url"
      @getData="getData"
    ></Del>
    <Down
      :showInputDialog.sync="Downloading"
      ref="Del"
      :url="url"
      @getData="getData"
    ></Down>

  </div>
</template>

  <script>
import Del from "@/components/log-service/local/del.vue";
import Down from "@/components/log-service/local/down.vue";

export default {
  components: { Del, Down },
  props:{
    productKey:{}
  },
  data() {
    return {
      Delloading: false,
      currentPage: 1,
      pageSize: 200,
      total: 0,
      infoData: {},
      table: [],
      file_url: "",
      searchValue:'',
      Downloading:false,
      disable: true,
      placeholder: '未选择产品时不允许输入',
      url:''
    };
  },
  watch:{
    productKey(newdata){
      if(newdata == ''){
        this.searchValue = ''
      }
      this.placeholder = newdata == '' ? '未选择产品时不允许输入' : '请输入文件名'
      this.disable = newdata == '' ? true : false
      this.productKey = newdata
  },
  },
  created() {
    this.getData();
  },
  methods: {
    setRowClass({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "background: #fafafa";
      }
    },
    async getData() {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        // page_num: this.currentPage,
        product_key: this.productKey,
        obj_key: this.searchValue,
        size: this.pageSize,
      };
      const res = await this.$getData(
        "/td/td-iot-api/iot/log/dev/local/get/list/v1",
        subData
      );
      if (res.code === 0) {
        this.table = res.data.list;
        this.total = res.data.total;
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },

    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1
      this.getData();
    },

    showDelModel(row) {
      this.file_url = row.url;
      this.Delloading = !this.Delloading;
    },
    showDownModel(row) {
      this.url = row.url;
      this.Downloading = !this.Downloading;
    },

  },
  beforeDestroy() {},
};
</script>
  <style lang="scss">
.low-title {
  font-size: 18px;
}
</style>
